/* eslint-disable @angular-eslint/no-input-rename */
import {
  Input,
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SharedModule } from '../../../shared.module';

@Component({
  selector: 'app-widget-summary-display',
  templateUrl: './widget-summary-display.component.html',
  styleUrls: [
    '../common/styles/widget-element.scss',
    './widget-summary-display.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SharedModule],
})
export class WidgetSummaryDisplayComponent {
  @Input({ alias: 'user.billingAddress' }) userBillingAddress: string;

  @Input({ alias: 'user.accountName' }) userAccountName: string;

  @Input({ alias: 'user.phone' }) userPhone: number | string;

  @Input({ alias: 'user.firstName' }) userFirstName: string;

  @Input({ alias: 'user.lastName' }) userLastName: string;

  @Input({ alias: 'user.title' }) userTitle: string;

  @Input({ alias: 'user.email' }) userEmail: string;

  @Input() loading: boolean = true;
}
